import { render } from "./ColorPicker.vue?vue&type=template&id=9822a7d4"
import script from "./ColorPicker.vue?vue&type=script&lang=ts"
export * from "./ColorPicker.vue?vue&type=script&lang=ts"
script.render = render

export default script